import { render } from "./BannerHome.vue?vue&type=template&id=47414027&scoped=true"
import script from "./BannerHome.vue?vue&type=script&lang=js"
export * from "./BannerHome.vue?vue&type=script&lang=js"

import "./BannerHome.vue?vue&type=style&index=0&id=47414027&lang=scss&scoped=true"
import "./BannerHome.vue?vue&type=style&index=1&id=47414027&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47414027"]])

export default __exports__